// import { Box } from "@mui/material";
import { MouseEventHandler, useState } from "react";
// import ViewQuiltOutlinedIcon from "@mui/icons-material/ViewQuiltOutlined";
import { AddCircle, FileUploadOutlined } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { useAtom } from "jotai";
import IwButton from "../../components/app/IwButton";
import MaterialModal from "../../components/app/material-modal";
import MaterialInterviewDetails from "../../components/discovery/interview/material-interview-details";
import { baseAtom } from "../../stores/jotai/base";
import { StepperCountBox } from "./common/StepperCountBox";
import BGStep4 from "./icon/BGStep4";
import { hasPermissionCanvasWrite } from "../../stores/jotai/permissions";

interface IemptySegmentContent {
  message: string;
  action: MouseEventHandler<HTMLButtonElement>;
}

const EmptyInterviewCard = () => {
  const [isInterviewCreationModalOpen, setIsInterviewCreationModalOpen] =
    useState<boolean>(false);
  const [base, setBase] = useAtom(baseAtom);
  const canCreateInterviews = hasPermissionCanvasWrite(base);
  const handleInterviewModalClose = () => {
    setIsInterviewCreationModalOpen(false);
  };

  const onUploadButtonClick = () => {
    try {
      document.getElementById("recording-upload")?.click();
    } catch (e) {}
  };

  return (
    <>
      <MaterialModal
        title="Create Interview"
        open={isInterviewCreationModalOpen}
        onClose={handleInterviewModalClose}
        handleDialogClose={handleInterviewModalClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              minHeight: "500px",
              minWidth: "780px"
            }
          }
        }}
      >
        <MaterialInterviewDetails
          showSaveAndOpenButton={true}
          style={{ width: "812px" }}
          interview={{}}
          import={undefined}
          existingInterview={false}
          audioImportDoneUploading={true}
          close={handleInterviewModalClose}
          errors={{}}
          handleErrors={() => {}}
          setBase={setBase}
        />
      </MaterialModal>

      <Box
        sx={{
          height: "100%",
          p: 2,
          backgroundColor: "white",
          opacity: 0.9,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxShadow:
            "0 0 0 0.67px rgba(0, 0, 0, 0.09), 0 34px 20px rgba(0, 0, 0, 0.024)"
        }}
      >
        <Stack direction="column" alignItems="center" spacing={2}>
          <StepperCountBox stepperCount={4} text="Interview your Customers" />

          <BGStep4 width={"260px"} height={"inherit"} />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1
            }}
          >
            <Typography
              variant="h6"
              component="div"
              textAlign="center"
              fontSize="16px"
            >
              Manage your interviews easily.
            </Typography>
            <Typography variant="body2" textAlign="center" fontSize="15px">
              Upload or create interviews—all your interview in one place.
            </Typography>
          </Box>
          <Stack direction="row" alignItems="center" spacing={2}>
            <IwButton
              variant="outlined"
              disabled={!base?.roleSnapshot?.isTeamMember}
              startIcon={<AddCircle width={24} />}
              size="large"
              onClick={() => {
                setIsInterviewCreationModalOpen(true);
              }}
            >
              Create Interview
            </IwButton>
            <IwButton
              variant="contained"
              startIcon={<FileUploadOutlined />}
              size="large"
              onClick={() => {
                onUploadButtonClick();
              }}
              disabled={!canCreateInterviews}
            >
              Upload Interview
            </IwButton>
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default EmptyInterviewCard;
